/** Колокольчик call: контур без заливки, цвет — от кнопки. */
export function Bell(): React.ReactElement {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
      <path d="M8 2.4A3.4 3.4 0 0 1 11.4 5.8v2l1.3 2.4H3.3L4.6 7.8v-2A3.4 3.4 0 0 1 8 2.4Z" />
      <path d="M6.6 13.1a1.6 1.6 0 0 0 2.8 0" />
    </svg>
  );
}
